<template>
  <div class="side-wrapper p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="section-wrapper d-flex py-3">
          <div class="root-img d-flex" v-if="compliant">
              <img
                :src="$root.serverBasePath + '/verified.png'"
                alt="Strata Connex"
                height="40px"
              />

              <p class="ml-3 mb-0">
                Verified by Strata Connex<br />
                <span>100% Compliant</span>
              </p>
          </div>
          <div class="root-img d-flex" v-else>
              <i
                style="font-size: 40px"
                class="fas fa-exclamation-circle fa-2x unverified"
              ></i>

              <p class="ml-3 mb-0">Not Verified by Strata Connex<br /></p>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-section bg-white p-3">
      <div class="row">
        <div v-if="abn_acn" class="col-lg-12">
          <div class="abn-details">
            <h4>ABN Details - {{ abn_acn.abn_acn }}</h4>
            <i
              class="bi bi-shield-check"
              v-if="abn_acn.abn_acn_status == 'verified'"
            >
            </i>
            <SvgIcons
              v-else
              icon="icon-error"
              width="45"
              height="55"
              svgClass="mb-1 mr-4 pull-right"
              style="position: absolute; top: 20px; right: -18px"
            />
          </div>

          <!-- <p>{{abn_acn_info.type}} Details - <b>{{abn_acn_info.abn_acn}}</b></p> -->
          <div v-if="abn_acn.abn_acn_status == 'verified'">
            <ul style="margin-bottom: 0">
              <li v-if="abn_acn.company_name">
                <span class="title">Business Name :</span>
                <span class="sub-title">{{ abn_acn.company_name }}</span>
              </li>
            </ul>

            <div v-if="abn_acn.abn_acn_info">
              <ul>
                <li
                  v-if="
                    abn_acn.abn_acn_info && abn_acn.abn_acn_info.entity_name
                  "
                >
                  <span class="title">Entity name :</span>
                  <span class="sub-title">{{
                    abn_acn.abn_acn_info.entity_name
                  }}</span>
                </li>

                <li
                  v-if="abn_acn.abn_acn_info && abn_acn.abn_acn_info.abn_status"
                >
                  <span class="title">Status:</span>
                  <span class="sub-title">{{
                    abn_acn.abn_acn_info.abn_status
                  }}</span>
                </li>

                <li
                  v-if="
                    abn_acn.abn_acn_info && abn_acn.abn_acn_info.entity_type
                  "
                >
                  <span class="title"> Entity type :</span>
                  <span class="sub-title">{{
                    abn_acn.abn_acn_info.entity_type
                  }}</span>
                </li>

                <li v-if="abn_acn.abn_acn_info && abn_acn.abn_acn_info.gst">
                  <span class="title">Goods &amp; Services Tax (GST) :</span>
                  <span class="sub-title"
                    >Registered From
                    {{ momentDate(abn_acn.abn_acn_info.gst) }}</span
                  >
                </li>

                <li
                  v-if="
                    abn_acn.abn_acn_info &&
                    abn_acn.abn_acn_info.main_business_location
                  "
                >
                  <span class="title">Main business location :</span>
                  <span class="sub-title">{{
                    abn_acn.abn_acn_info.main_business_location
                  }}</span>
                </li>

                <li
                  v-if="
                    abn_acn.abn_acn_info &&
                    abn_acn.abn_acn_info.abn_last_updated
                  "
                >
                  <span class="title">Last updated :</span>
                  <span class="sub-title">{{
                    momentDate(abn_acn.abn_acn_info.abn_last_updated)
                  }}</span>
                </li>

                <li
                  v-if="
                    abn_acn.abn_acn_info &&
                    abn_acn.abn_acn_info.record_extracted
                  "
                >
                  <span class="title">Record extracted :</span>
                  <span class="sub-title">{{
                    momentDate(abn_acn.abn_acn_info.record_extracted)
                  }}</span>
                </li>
              </ul>
            </div>
            <div v-else>
              <p>Other data not available yet.</p>
            </div>
          </div>
          <div v-else>
            <p>Sorry, Business details not verified yet.</p>
          </div>

          <b-button
            :to="{ name: 'contractor-compliance' }"
            type="button"
            variant="outline-primary"
            >Close</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import SvgIcons from "@frontend/pages/includes/SvgIconsComponent.vue";

export default {
  data() {
    return {
      abn_acn: {
        abn_acn_info: {},
      },
      compliant: false,
    };
  },
  components: {
    SvgIcons,
  },
  mounted() {
    this.checkComplaint();
    this.getDetails();
  },
  methods: {
    getDetails() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/compliance/getAbnAcn")
        .then((response) => {
          this.abn_acn = response.data.business_abn_acn_info;
          this.$root.$data.bsLoader = false;
        })
        .catch((error) => {
          this.$root.$data.bsLoader = false;
        });
    },
    checkComplaint() {
      axios
        .post("api/contractor/compliance/checkCompliant")
        .then((response) => {
          if (response.data.check_compliant) {
            this.compliant = true;
          }
        });
    },
    fetchAbnAcnDetails() {
      axios
        .post("api/contractor/compliance/fetchAbnAcnDetails")
        .then((response) => {
          this.getDetails();
        });
    },
    momentDate: function (date) {
      return moment(date).format("D MMM YYYY");
    },
  },
};
</script>

<style scoped>
.side-wrapper {
  background-color: #eff0f6;
  min-height: 100vh;
}

.abn-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.abn-details h4 {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 10px;
}

.abn-details i {
  color: #00ba88;
  font-size: 20px;
}

.unverified {
  color: #e83e8c;
}
</style>